import { PropsWithChildren, useEffect } from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Typography } from '@mui/material';
import { loginConfig } from '../utils/loginConfig.ts';

export const PrivateRoute = ({ children }: PropsWithChildren) => {
  const { isAuthenticated, loginWithRedirect, isLoading, getAccessTokenSilently } = useAuth0();

  useEffect(() => {
    const login = async () => {
      try {
        await getAccessTokenSilently();
      } catch {
        await loginWithRedirect(loginConfig(window.location.pathname));
      }
    };

    if (!isLoading && !isAuthenticated) {
      login();
    }
  }, [loginWithRedirect, isAuthenticated, isLoading, getAccessTokenSilently]);

  if (isLoading) {
    return <Typography>Loading&hellip;</Typography>;
  }

  return children;
};
